// extracted by mini-css-extract-plugin
export var container = "news-module--container--i-2zw";
export var wrapper = "news-module--wrapper--zpcVx";
export var title = "news-module--title--1NYbk";
export var newsItems = "news-module--newsItems--FCTRs";
export var newsItem = "news-module--newsItem--22EXM";
export var newsItemImg = "news-module--newsItemImg--3Jhdq";
export var newsDate = "news-module--newsDate--23T-0";
export var newsDesc = "news-module--newsDesc--2wLM_";
export var newsSummary = "news-module--newsSummary--10NCy";